export const getSaldoKasSaatIni = (transactions) => {
    if (!Array.isArray(transactions) || transactions.length === 0) {
        return 0;
    }

    return transactions.reduce((saldoAkhir, item) => {
        const nominal = Number(item.nominal) || 0;
        const tipe = (item.tipe || '').toLowerCase();

        if (tipe === 'pemasukan') {
            return saldoAkhir + nominal;
        }

        if (tipe === 'pengeluaran') {
            return saldoAkhir - nominal;
        }

        // Abaikan tipe lain (transfer, penyesuaian, dll)
        return saldoAkhir;
    }, 0);
};
